import { render, staticRenderFns } from "./NutritionInfo.vue?vue&type=template&id=e5c62dac&scoped=true&"
import script from "./NutritionInfo.vue?vue&type=script&lang=js&"
export * from "./NutritionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c62dac",
  null
  
)

export default component.exports